// shareCardEndpoint — resolves the shareable slip card URL. The card
// is now a SERVER-SIDE rendered image (PRD §7.3) at the
// intl-acca-share-card edge function, REPRODUCIBLE FROM slip_id ALONE.
// An optional referral code personalises the embedded referral link
// (§12 non-negotiable — a link is always present; absent code ⇒
// generic strikza.io landing). Deep-linkable and identical whether
// opened from the Home feed or the slip detail page.

/** Canonical server-rendered share-card image URL for a slip. */
export function shareCardUrl(slipId: string, refCode?: string | null): string {
  const base = import.meta.env.VITE_SUPABASE_URL;
  const q = new URLSearchParams({ slip_id: slipId });
  if (refCode) q.set("ref", refCode);
  return `${base}/functions/v1/intl-acca-share-card?${q.toString()}`;
}

/** Open the share card in a new tab. No-op when slipId is empty. */
export function openShareCard(slipId: string, refCode?: string | null): void {
  if (!slipId) return;
  window.open(shareCardUrl(slipId, refCode), "_blank", "noopener");
}
